// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { Header, Icon } from "semantic-ui-react";
import * as api from "../../../../config/api";
import * as i18n from "../../../../config/i18n";
import { ApplicationList } from "../../../../components/ApplicationList";
import { ApplicationLoader } from "../../../../components/ApplicationLoader";
import { TenantListItem } from "./TenantListItem";
import { privateApi } from "../../../../api";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TenantList = props => {
  const {
    items,
    selected,
    onSelect
  } = props;
  const [tenants, setTenants] = React.useState(items);
  const [loading, setLoading] = React.useState(_.isEmpty(tenants));
  React.useEffect(() => {
    privateApi.get(api.tenantsEndPoint).then(results => {
      setTenants(results);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  const handleClick = React.useCallback(value => {
    onSelect?.(value);
  }, [onSelect]);
  const empty = React.useMemo(() => /*#__PURE__*/_jsxs(Header, {
    icon: true,
    children: [/*#__PURE__*/_jsx(Icon, {
      className: "outline",
      name: "building"
    }), i18n.userTenantNoResult]
  }), []);
  const tenantList = React.useMemo(() => /*#__PURE__*/_jsx(ApplicationList, {
    placeholder: empty,
    divided: true,
    children: _.map(tenants, t => /*#__PURE__*/_jsx(TenantListItem, {
      identifiant: t.identifiant,
      nom: t.nom,
      selected: t.identifiant === selected?.identifiant,
      onClick: handleClick
    }, t.identifiant))
  }), [tenants, selected, handleClick]);
  return React.useMemo(() => loading ? /*#__PURE__*/_jsx(ApplicationLoader, {}) : tenantList, [tenantList, loading]);
};